import React, { useEffect } from "react"

//Utils
import { useRouter } from "next/router"

//Components
import { Input, Select, Check, Button, ButtonGroup } from "components/anti"
import ico_discount from "assets/img/icon/ico_discount.svg"
import { BagItem } from "./bag-item"
import { useDispatch, useSelector } from "react-redux"
import { currencyFormatter } from "lib/utils/utils"
import { ModalCheckoutContinue } from "@components/modals"
import {
  ModalLogin,
  ModalRegister,
  ResetPassword,
} from "@components/modal-component"
import { SET_SHOW_LOGIN } from "lib/redux/types"
import { sendDatalayerProduct } from "lib/function"

const CartComp = ({
  locale,
  locales,
  data,
  dataWishlist,
  token,
  carts: cartsNotLogin,
  setCartState,
}) => {
  const dispatch = useDispatch()
  const [modal, setModal] = React.useState(null)
  const [modalLogin, setModalLogin] = React.useState(null)
  const modalLoginId = "modal-login-id"
  const modalRegister = "modal-register-id"
  const modalResetPassword = "modal-reset-password"
  const [btnLoading, setBtnLoading] = React.useState(null)
  const [authState, setAuthState] = React.useState({
    isLogin: false,
    showLoginModal: null,
    showRegisterModal: null,
    showModalReset: null,
  })

  //Utils
  const Router = useRouter()
  const { carts, user_data } = useSelector((state) => state.auth)
  let { showLogin } = useSelector((state) => state.general)

  const handleNavigate = () => {
    if (user_data) {
      setBtnLoading(true)
      sendDatalayerProduct({
        event: "begin_checkout",
        data: { ...carts },
        type: 3,
      })
      return Router.push("/checkout")
    } else setModal("modal-checkout")
  }

  //React Operations ******************************************************************** //
  const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect

  // useIsomorphicLayoutEffect(() => {
  //   document.documentElement.classList.add("enable-sticky")
  // }, [])

  React.useEffect(() => {
    if (carts) {
      setCartState(carts)
    }
  }, [carts])
  //React Operations ******************************************************************** //

  return (
    <div className="sc-carts">
      <ModalCheckoutContinue
        id={"modal-checkout"}
        show={modal}
        hide={() => setModal(null)}
        callback={() => {
          setAuthState((prev) => ({
            ...prev,
            showLoginModal: modalLoginId,
          }))
          setModal(null)
        }}
        carts={carts}
      />
      <ResetPassword
        id={modalResetPassword}
        isShowing={authState.showModalReset}
        hide={() => setAuthState((prev) => ({ ...prev, showModalReset: null }))}
      />
      <ModalLogin
        id={modalLoginId}
        show={authState.showLoginModal || showLogin}
        onClickReset={() => {
          setAuthState((prev) => ({
            ...prev,
            showModalReset: modalResetPassword,
            showLoginModal: null,
          }))
          dispatch({ type: SET_SHOW_LOGIN, payload: null })
        }}
        callback={() => {
          setAuthState((prev) => ({
            ...prev,
            showRegisterModal: modalRegister,
            showLoginModal: null,
          }))
          dispatch({ type: SET_SHOW_LOGIN, payload: null })
        }}
        hide={() => {
          setAuthState((prev) => ({ ...prev, showLoginModal: null }))
          dispatch({ type: SET_SHOW_LOGIN, payload: null })
        }}
      />
      <ModalRegister
        id={modalRegister}
        show={authState.showRegisterModal}
        callback={() => {
          setAuthState((prev) => ({
            ...prev,
            showRegisterModal: null,
            showLoginModal: modalLoginId,
          }))
        }}
        hide={() =>
          setAuthState((prev) => ({ ...prev, showRegisterModal: null }))
        }
      />
      <div className="container mw-xl">
        <div className="btn-back-wrapper">
          <span
            className="ail ai-arrow-left font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={() => Router.back()}
          />
        </div>
        <h3 className="title-page">
          {locale === "id" ? "Keranjang Belanja Saya" : "My Shopping Cart"}
        </h3>
        <div className="row wrapper-carts">
          <div className="col-md-7">
            <div className="list-carts">
              {carts?.items?.length > 0 ? (
                <>
                  {carts.items?.map((item, i) => (
                    <BagItem
                      token={token}
                      {...item}
                      index={i + 1}
                      key={i}
                      locale={locale}
                    />
                  ))}
                </>
              ) : cartsNotLogin?.items?.length > 0 ? (
                <>
                  {cartsNotLogin.items?.map((item, i) => (
                    <BagItem
                      token={token}
                      {...item}
                      index={i + 1}
                      key={i}
                      locale={locale}
                    />
                  ))}
                </>
              ) : null}
            </div>
          </div>
          <div className="col-md-5 mt-3 mt-sm-0">
            <div className="sticky-top">
              <div className="order-summary">
                <h5 className="text-summary">
                  {locale === "id" ? "Ringkasan Belanja" : "Shopping Summary"}
                </h5>
                <div className="detail-wrapper">
                  <h5 className="desc-detail">
                    {locale === "id"
                      ? `Total Harga (${carts?.items?.length ?? 0} Barang )`
                      : `Total Price (${carts?.items?.length ?? 0} Items )`}
                  </h5>
                  <h5 className="value-detail">
                    {carts?.grand_total
                      ? currencyFormatter("ID", carts?.grand_total)
                      : "-"}
                  </h5>
                </div>
                <hr />
                <div className="detail-total">
                  <h5 className="subtotal">Subtotal</h5>
                  <h5 className="grand-total">
                    {carts?.grand_total
                      ? currencyFormatter("ID", carts?.grand_total)
                      : "-"}
                  </h5>
                </div>
                <Button
                  className={`w-100 ${btnLoading ? "loading" : ""}`}
                  loader
                  variant="primary"
                  onClick={handleNavigate}
                  disabled={!carts?.items?.length > 0}
                >
                  Checkout
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CartComp
